import { createRoute,Outlet } from '@tanstack/react-router'

import { rootRoute } from '../root'

export const casinoRoute = createRoute({
  getParentRoute: () => rootRoute,
  path: 'casino',
  component: Outlet,
})
